/* global window */
import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { onSelection } from "../../../helpers/selection";
import { updateBackground, updateGlobal } from "../../../state/cellStylesSlice";
import ColorPickerSubMenu from "../submenus/ColorPickerSubMenu";
import { useTranslation } from "react-i18next";
import { openStyleSheetDialog } from "../../../state/appStateSlice";

const BackgroundColorMenuItem = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selection = useSelector((state) => state.selection);
  const structure = useSelector((state) => state.gridd.present.structure);
  const cellId = selection.cells[0]?.id;
  const currentStyle = useSelector((state) => state.gridd.present.cellStyles[cellId]);
  const moatColor = useSelector((state) => state.gridd.present.cellStyles.global?.moatColor);

  return (
    <div id="context_menu_item_background" style={{ display: "grid", gridTemplateRows: "auto 1fr auto auto auto" }}>
      <div>{t("background.cell.header")}</div>
      <div>
        <ColorPickerSubMenu
          id="background_color"
          color={currentStyle?.background}
          enabled={["nocolor", "background", "base", "diverging", "sequential", "status"]}
          hideLink
          onNewColor={(newColor, newName) => {
            onSelection(
              dispatch,
              updateBackground,
              { selection, structure },
              { background: newColor, backgroundName: newName }
            );
          }}
        />
      </div>
      <div style={{ marginTop: 4 }}>{t("background.moat.header")}</div>
      <div>
        <ColorPickerSubMenu
          id="moat_color_picker"
          color={moatColor}
          enabled={["nocolor", "background"]}
          hideLink
          onNewColor={(newColor, newName) => {
            onSelection(
              dispatch,
              updateGlobal,
              { selection, structure },
              { moatColor: newColor, moatColorName: newName }
            );
          }}
        />
      </div>
      <div style={{ marginTop: 8, justifySelf: "right" }}>
        <a
          href="#"
          style={{
            color: "#0065FD",
            textDecoration: "none",
            cursor: "pointer",
            fontSize: "14px",
          }}
          onClick={(e) => {
            e.preventDefault();
            dispatch(openStyleSheetDialog());
            // TODO: refactor to dispatch action payload and
            // let stylesheet dialog handle the scroll after it mounted:
            window.setTimeout(() => {
              const tab = window.document.getElementById("colors");
              if (tab) tab.click();
            }, 100);
          }}
        >
          {t("menu.stylesheet.editStyleSheetColors")}
        </a>
      </div>
    </div>
  );
};

export default BackgroundColorMenuItem;
